<template>
  <Dialog>
    <DialogTrigger class="btn btn-outline-primary">
      {{ $t('Details') }}
    </DialogTrigger>
    <DialogScrollContent size="lg">
      <DialogHeader>
        <DialogTitle>
          {{ activityName }}
        </DialogTitle>
      </DialogHeader>
      <div class="table-responsive mt-3">
        <table class="table table-striped">
          <thead>
          <tr>
            <th>{{ translateTitles.id }}</th>
            <th>{{ translateTitles.quota_total }}</th>
            <th>{{ translateTitles.quota_used }}</th>
            <th>{{ translateTitles.quota_remaining }}</th>
            <th>{{ translateTitles.quota_percentage_used }}</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(variant, index) in activityVariantsQuota"
            :key="index"
          >
            <td class="align-middle">
              <div v-for="(activityOption , index) in activityOptions" :key="index">
                    <span class="badge badge-light">
                      {{ activityOption.code }} : {{ variant.activity_option_values.find((ov) => ov.activity_option_id === activityOption.id)?.code }}
                    </span>
              </div>
            </td>
            <td class="align-middle">
              <!-- No cap was set on this variant, so the columns that only mean
                   something against one say so rather than showing a nought. -->
              <span v-if="variant.quota.total === null" class="text-muted">{{ $t('No limit') }}</span>
              <template v-else>{{ variant.quota.total }}</template>
            </td>
            <td class="align-middle">
              {{ variant.quota.used }}
            </td>
            <td class="align-middle">
              {{ variant.quota.total === null ? '—' : variant.quota.remaining }}
            </td>
            <td class="align-middle">
              <QuotaIndicator :quota="variant.quota"></QuotaIndicator>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup>
import { Dialog, DialogScrollContent, DialogTrigger, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import QuotaIndicator from "@/components/QuotaIndicator.vue";

const props = defineProps({
  activityVariantsQuota: {
    type: Array,
    required: true,
  },
  translateTitles: {
    type: Object,
    required: true,
  },
  activityName: {
    type: String,
    required: true,
  },
  activityOptions: {
    type: Array,
    required: true,
  }
})
</script>
